export const CROSS_SELL_CHARGER_FIELD_NAME = 'addedCrossSellCharger';
